import { Switch } from "antd";

/**
 * createColumns
 * Complemento para mostrar las tablas tanto como en antd y modo responsive
 * @param {Function} showEditModal
 * @param {Function} showDeleteModal
 * @param {Number} page
 * @param {Boolean} porSedeEnabled
 */
export function createColumns(
  page = 1,
  onChangeState = null,
  porSedeEnabled = false,
  porPeriodoEnabled = false
) {
  const columns = [
    {
      title: "N.º",
      key: "index",
      render: (value, item, index) => (page - 1) * 10 + index + 1
    },
    {
      title: "Código",
      dataIndex: "codigo",
      key: "codigo",
      sorter: (a, b) => a.codigo.localeCompare(b.codigo)
    },
    {
      title: "DNI",
      dataIndex: "nrodocumento",
      key: "nrodocumento",
      sorter: (a, b) => a.nrodocumento.localeCompare(b.nrodocumento),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Apellido",
      dataIndex: "apellido",
      key: "apellido",
      sorter: (a, b) => a.apellido.localeCompare(b.apellido),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Canal",
      dataIndex: "idcanal",
      key: "idcanal",
      sorter: (a, b) => a.idcanal.localeCompare(b.idcanal),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Carrera",
      dataIndex: "carrera",
      key: "carrera",
      sorter: (a, b) => a.carrera.localeCompare(b.carrera),
      sortDirections: ["descend", "ascend"]
    }
  ];

  // Agregar columna de sede solo si porSedeEnabled es true
  if (porSedeEnabled) {
    columns.push({
      title: "Sede",
      dataIndex: "sede",
      key: "sede",
      sorter: (a, b) => (a.sede || "").localeCompare(b.sede || ""),
      sortDirections: ["descend", "ascend"]
    });
  }

  if (porPeriodoEnabled) {
    columns.push({
      title: "Periodo",
      dataIndex: "periodo",
      key: "periodo",
      sorter: (a, b) => (a.periodo || "").localeCompare(b.periodo || ""),
      sortDirections: ["descend", "ascend"]
    });
  }

  columns.push({
    title: "Acciones",
    key: "action",
    render: (record) => (
      <Switch size="small" checked={record.activo} onChange={() => onChangeState(record)} />
    )
  });

  return columns;
}
